import { useState } from "react";

import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import PropTypes from "prop-types";

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const ImageUpload = ({ fileList, handleFileChange, maxCount = 10, listType = "picture-card" }) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState("");

    const handlePreview = async (file) => {
        let previewUrl = file.url || file.preview;

        if (!previewUrl && file.originFileObj) {
            previewUrl = await getBase64(file.originFileObj);
        }

        setPreviewImage(previewUrl);
        setPreviewOpen(true);
    };

    const handleChange = ({ fileList: newFileList }) => {
        handleFileChange(newFileList);
    };

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: "none",
            }}
            type="button">
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}>
                Upload
            </div>
        </button>
    );

    // const customItemRender = (originNode, file) => (
    //     <div
    //         style={{
    //             width: "84px",
    //             height: "84px",
    //             padding: "8px",
    //             border: "1px solid #d9d9d9",
    //             borderRadius: "8px",
    //             display: "flex",
    //             justifyContent: "center",
    //             alignItems: "center",
    //         }}>
    //         <img
    //             src={file.thumbUrl || file.url}
    //             alt={file.name}
    //             style={{
    //                 width: "100%",
    //                 height: "100%",
    //                 objectFit: "cover",
    //             }}
    //         />
    //     </div>
    // );

    return (
        <>
            <Upload
                // itemRender={customItemRender}
                beforeUpload={() => false}
                listType={listType}
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                accept="image/*">
                {fileList?.length >= maxCount ? null : uploadButton}
            </Upload>

            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: "none",
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                />
            )}
        </>
    );
};

ImageUpload.propTypes = {
    fileList: PropTypes.array.isRequired,
    handleFileChange: PropTypes.func.isRequired,
    maxCount: PropTypes.number,
    listType: PropTypes.string,
};

export default ImageUpload;
